import { createContext } from 'react';
import { onReactionError, configure } from 'mobx';
import { persistStoreCustomKey } from '@quan/mobx-logic';

import userStore, { UserStore } from './user';

configure({ enforceActions: 'observed' });

export enum StoreName {
  USERSTORE = 'userStore',
}

type IUserStoreProp = {
  [StoreName.USERSTORE]: UserStore;
};

export const persistUserStore = new Promise<UserStore>((resolve) => {
  resolve(
    persistStoreCustomKey<UserStore>(
      `quan-h5-${process.env.mode}-${StoreName.USERSTORE}`,
      userStore,
    ),
  );
});

export const IS_WX_SCRIPT_LOAD = createContext<boolean>(false);

export { UserStore };
export type { IUserStoreProp };

onReactionError((err, derivation) => {
  console.error(derivation, err);
});
